import { Card, CardContent, Stack, Avatar, Typography, Chip } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

export function AccountInfo() {
  const user = useSelector((state: RootState) => state.auth.user);
  const first = user?.first_name ?? "Guest";
  const last = user?.last_name ?? "User";
  const initials = `${first?.[0] ?? ""}${last?.[0] ?? ""}`.toUpperCase();

  return (
    <Card>
      <CardContent>
        <Stack spacing={2} sx={{ alignItems: "center", py: 2 }}>
          <Avatar
            sx={{
              height: 88,
              width: 88,
              bgcolor: "primary.main",
              color: "primary.contrastText",
              fontSize: 30,
              fontWeight: 700,
            }}
          >
            {initials || "?"}
          </Avatar>
          <Stack spacing={1} sx={{ alignItems: "center", textAlign: "center" }}>
            <Typography variant="h6">
              {first} {last}
            </Typography>
            {user?.email && (
              <Typography color="text.secondary" variant="body2">
                {user.email}
              </Typography>
            )}
            <Chip
              size="small"
              color="primary"
              variant="outlined"
              label={user?.group?.title ?? "user"}
              sx={{ textTransform: "capitalize", fontWeight: 600 }}
            />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
